/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { useMDSLink } from '../../../utils/mds-context'
import type { BreadcrumbItemProps } from '../types'
import s from '../style.module.scss'

interface ItemContentProps {
	text: string
	/**
	 * Use to show an flight icon.
	 */
	icon?: React.ReactNode
}

const ItemContent = ({ icon, text }: ItemContentProps) => {
	return (
		<>
			{icon && <div className={s.icon}>{icon}</div>}

			<span className={s.text}>{text}</span>
		</>
	)
}

export const Item = ({
	maxWidth,
	current,
	icon,
	text,
	url,
	...rest
}: BreadcrumbItemProps) => {
	const Link = useMDSLink()

	return (
		<li
			className={s.item}
			style={{
				...(maxWidth && { maxWidth }),
			}}
			{...rest}
		>
			{current ? (
				<div className={s.current}>
					<ItemContent icon={icon} text={text} />
				</div>
			) : (
				<Link className={s.link} href={url}>
					<ItemContent icon={icon} text={text} />
				</Link>
			)}
		</li>
	)
}
